const getters = {
	origin: () => process.env.VUE_APP_SPACEIN_API_NOTIFICATIONS_URL,
	pathPrefix: () => '/notifications-api'
}

const actions = {
	request({dispatch, getters}, data) {
		return dispatch('api/requests/sendAxiosRequest', {
			...data,
			url: getters.origin+getters.pathPrefix+data.url,
		}, {root: true});
	},


	getAll({dispatch, rootGetters}){
		return dispatch('request', {
			url: `/notifications`,
			method: 'get',
			params: {
				locationId: rootGetters.getCurrentAreaData.id
			}
		})
	},
	clearOne({dispatch}, notificationId){
		return dispatch('request', {
			url: `/notifications/clear`,
			method: 'delete',
			params: {notificationId}
		})
	},
	clearAll({dispatch, rootGetters}, sent){
		return dispatch('request', {
			url: `/notifications/clear-all`,
			method: 'delete',
			params: {
				locationId: rootGetters.getCurrentAreaData.id,
				sent
			}
		})
	}
}

export default {
	namespaced: true,
	actions,
	getters
};
